import { LoggedInHandleParamsType } from '../types';
import AbstractLoggedInHandler from './AbstractLoggedInHandler';

export default class DefaultHandler extends AbstractLoggedInHandler {
  public async handle(params: LoggedInHandleParamsType): Promise<void> {
    const { proceedToShell, manifest, decodedState } = params;
    return proceedToShell(manifest, decodedState);
  }
}
